import React from 'react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';

const topics: TopicItem[] = [
  {
    id: 'introduction',
    title: 'Introduction',
    completed: false,
    children: [
      { id: 'intro-1', title: 'What is System Design?', completed: false },
      { id: 'intro-2', title: 'Why System Design Matters', completed: false },
      { id: 'intro-3', title: 'Top 30 System Design Concepts', completed: false },
      { id: 'intro-4', title: 'System Design Interviews', completed: false },
      { id: 'intro-quiz', title: 'Introduction Quiz', completed: false },
    ],
  },
  {
    id: 'sd-fundamentals',
    title: 'System Design Fundamentals',
    completed: false,
    children: [
      { id: 'sd-fund-1', title: 'Client-Server Architecture', completed: false },
      { id: 'sd-fund-2', title: 'Proxy & Reverse Proxy', completed: false },
      { id: 'sd-fund-3', title: 'Load Balancing Overview', completed: false },
      { id: 'sd-fund-4', title: 'Caching Overview', completed: false },
      { id: 'sd-fund-5', title: 'Database Overview', completed: false },
      { id: 'sd-fund-6', title: 'Message Queue Overview', completed: false },
    ],
  },
  {
    id: 'core-concepts',
    title: 'Core Concepts',
    completed: false,
    children: [
      { id: 'scalability', title: 'Scalability', completed: false },
      { id: 'availability', title: 'Availability', completed: false },
      { id: 'reliability', title: 'Reliability', completed: false },
      { id: 'durability', title: 'Durability', completed: false },
      { id: 'fault-tolerance', title: 'Fault Tolerance', completed: false },
      { id: 'consistency-models', title: 'Consistency Models', completed: false },
      { id: 'cap-theorem', title: 'CAP Theorem', completed: false },
      { id: 'consistent-hashing', title: 'Consistent Hashing', completed: false },
      { id: 'latency-throughput', title: 'Latency vs Throughput', completed: false },
      { id: 'spof', title: 'Single Point of Failure (SPOF)', completed: false },
      { id: 'core-concepts-quiz', title: 'Quiz', completed: false },
    ],
  },
  {
    id: 'networking',
    title: 'Networking',
    completed: false,
    children: [
      { id: 'networking-1', title: 'Networking Fundamentals', completed: false },
      { id: 'networking-2', title: 'TCP/IP', completed: false },
      { id: 'networking-3', title: 'HTTP/HTTPS', completed: false },
      { id: 'networking-3b', title: 'HTTP/HTTPS Lifecycle', completed: false },
      { id: 'networking-4', title: 'WebSockets', completed: false },
      { id: 'networking-5', title: 'gRPC', completed: false },
      { id: 'networking-7', title: 'Load Balancers', completed: false },
      { id: 'networking-8', title: 'CDN', completed: false },
      { id: 'networking-9', title: 'API Gateway', completed: false },
      { id: 'networking-10', title: 'Service Mesh', completed: false },
      { id: 'networking-quiz', title: 'Quiz', completed: false },
    ],
  },
  {
    id: 'api-fundamentals',
    title: 'API Fundamentals',
    completed: false,
    children: [
      { id: 'api-1', title: 'REST APIs', completed: false },
      { id: 'api-2', title: 'GraphQL', completed: false },
      { id: 'api-3', title: 'API Design Best Practices', completed: false },
      { id: 'api-4', title: 'API Versioning', completed: false },
      { id: 'api-5', title: 'Rate Limiting', completed: false },
      { id: 'api-6', title: 'API Security', completed: false },
      { id: 'api-7', title: 'API Documentation', completed: false },
      { id: 'api-8', title: 'API Testing', completed: false },
      { id: 'api-9', title: 'Webhooks', completed: false },
      { id: 'api-10', title: 'API Gateway Patterns', completed: false },
      { id: 'api-11', title: 'API Monitoring', completed: false },
    ],
  },
  {
    id: 'databases-storage',
    title: 'Databases & Storage',
    completed: false,
    children: [
      { id: 'db-1', title: 'SQL vs NoSQL', completed: false },
      { id: 'db-2', title: 'Database Indexing', completed: false },
      { id: 'db-3', title: 'Database Replication', completed: false },
      { id: 'db-5', title: 'ACID Properties', completed: false },
      { id: 'db-6', title: 'Database Transactions', completed: false },
      { id: 'db-7', title: 'Object Storage', completed: false },
      { id: 'db-8', title: 'Time-Series Databases', completed: false },
      { id: 'db-9', title: 'Graph Databases', completed: false },
      { id: 'db-10', title: 'Search Engines', completed: false },
      { id: 'db-11', title: 'Data Warehousing', completed: false },
      { id: 'db-12', title: 'Data Lakes', completed: false },
      { id: 'db-13', title: 'Database Backup & Recovery', completed: false },
    ],
  },
  {
    id: 'database-scaling',
    title: 'Database Scaling Techniques',
    completed: false,
    children: [
      { id: 'db-scale-1', title: 'Vertical Scaling', completed: false },
      { id: 'db-scale-2', title: 'Horizontal Scaling', completed: false },
      { id: 'db-scale-3', title: 'Read Replicas', completed: false },
      { id: 'db-4', title: 'Sharding', completed: false },
      { id: 'db-scale-4', title: 'Database Partitioning', completed: false },
      { id: 'db-scale-5', title: 'Federation', completed: false },
      { id: 'db-scale-6', title: 'Master-Slave Replication', completed: false },
      { id: 'db-scale-7', title: 'Master-Master Replication', completed: false },
      { id: 'db-scale-8', title: 'Database Clustering', completed: false },
      { id: 'db-scale-9', title: 'Connection Pooling', completed: false },
    ],
  },
  {
    id: 'caching',
    title: 'Caching',
    completed: false,
    children: [
      { id: 'cache-1', title: 'What is Caching?', completed: false },
      { id: 'cache-2', title: 'Read-Through vs Write-Through Cache', completed: false },
      { id: 'cache-3', title: 'Caching Strategies', completed: false },
      { id: 'cache-4', title: 'Cache Eviction Policies', completed: false },
      { id: 'cache-5', title: 'Distributed Caching', completed: false },
      { id: 'caching-quiz', title: 'Quiz', completed: false },
    ],
  },
  {
    id: 'async-communications',
    title: 'Asynchronous Communications',
    completed: false,
    children: [
      { id: 'async-1', title: 'Message Queues', completed: false },
      { id: 'async-2', title: 'Pub/Sub Pattern', completed: false },
      { id: 'async-3', title: 'Event-Driven Architecture', completed: false },
      { id: 'async-4', title: 'Stream Processing', completed: false },
      { id: 'async-5', title: 'Event Sourcing', completed: false },
    ],
  },
  {
    id: 'tradeoffs',
    title: 'Tradeoffs',
    completed: false,
    children: [
      { id: 'tradeoff-1', title: 'Consistency vs Availability', completed: false },
      { id: 'tradeoff-2', title: 'Latency vs Throughput', completed: false },
      { id: 'tradeoff-3', title: 'Cost vs Performance', completed: false },
      { id: 'tradeoff-4', title: 'Simplicity vs Flexibility', completed: false },
      { id: 'tradeoff-5', title: 'Monolith vs Microservices', completed: false },
      { id: 'tradeoff-6', title: 'SQL vs NoSQL', completed: false },
      { id: 'tradeoff-7', title: 'Synchronous vs Asynchronous', completed: false },
      { id: 'tradeoff-8', title: 'Strong Consistency vs Eventual Consistency', completed: false },
      { id: 'tradeoff-9', title: 'Vertical vs Horizontal Scaling', completed: false },
      { id: 'tradeoff-10', title: 'Read vs Write Optimization', completed: false },
    ],
  },
  {
    id: 'distributed-systems',
    title: 'Distributed System Concepts',
    completed: false,
    children: [
      { id: 'dist-1', title: 'Distributed Systems Basics', completed: false },
      { id: 'dist-2', title: 'Consensus Algorithms', completed: false },
      { id: 'dist-3', title: 'Leader Election', completed: false },
      { id: 'dist-4', title: 'Distributed Transactions', completed: false },
      { id: 'dist-5', title: 'Two-Phase Commit', completed: false },
      { id: 'dist-6', title: 'Saga Pattern', completed: false },
      { id: 'dist-7', title: 'Distributed Locking', completed: false },
      { id: 'dist-8', title: 'Quorum', completed: false },
      { id: 'dist-9', title: 'Vector Clocks', completed: false },
      { id: 'dist-10', title: 'Gossip Protocol', completed: false },
      { id: 'dist-11', title: 'Distributed Tracing', completed: false },
    ],
  },
  {
    id: 'design-patterns',
    title: 'Design Patterns (GoF)',
    completed: false,
    children: [
      { id: 'pattern-intro', title: 'Introduction to Design Patterns', completed: false },
      // 🏗 Creational Patterns
      { id: 'pattern-factory-method', title: '1. Factory Method', completed: false },
      { id: 'pattern-builder', title: '2. Builder', completed: false },
      { id: 'pattern-singleton', title: '3. Singleton', completed: false },
      { id: 'pattern-prototype', title: '4. Prototype', completed: false },
      { id: 'pattern-abstract-factory', title: '5. Abstract Factory', completed: false },
      // 🏛 Structural Patterns
      { id: 'pattern-adapter', title: '6. Adapter', completed: false },
      { id: 'pattern-decorator', title: '7. Decorator', completed: false },
      { id: 'pattern-facade', title: '8. Facade', completed: false },
      { id: 'pattern-proxy', title: '9. Proxy', completed: false },
      { id: 'pattern-composite', title: '10. Composite', completed: false },
      { id: 'pattern-bridge', title: '11. Bridge', completed: false },
      { id: 'pattern-flyweight', title: '12. Flyweight', completed: false },
      // 🧠 Behavioral Patterns
      { id: 'pattern-strategy', title: '13. Strategy', completed: false },
      { id: 'pattern-observer', title: '14. Observer', completed: false },
      { id: 'pattern-state', title: '15. State', completed: false },
      { id: 'pattern-command', title: '16. Command', completed: false },
      { id: 'pattern-chain-of-responsibility', title: '17. Chain of Responsibility', completed: false },
      { id: 'pattern-template-method', title: '18. Template Method', completed: false },
      { id: 'pattern-mediator', title: '19. Mediator', completed: false },
      { id: 'pattern-iterator', title: '20. Iterator', completed: false },
      { id: 'pattern-memento', title: '21. Memento', completed: false },
      { id: 'pattern-visitor', title: '22. Visitor', completed: false },
      // 🎯 Revision
      { id: 'pattern-comparisons', title: 'Pattern Comparisons', completed: false },
      { id: 'pattern-quiz', title: 'GoF Design Patterns Quiz', completed: false },
    ],
  },
  {
    id: 'architectural-patterns',
    title: 'Architectural Patterns',
    completed: false,
    children: [
      { id: 'arch-1', title: 'Monolithic Architecture', completed: false },
      { id: 'arch-2', title: 'Microservices Architecture', completed: false },
      { id: 'arch-3', title: 'Serverless Architecture', completed: false },
      { id: 'arch-4', title: 'Event-Driven Architecture', completed: false },
      { id: 'arch-5', title: 'Layered Architecture', completed: false },
      { id: 'arch-6', title: 'Hexagonal Architecture', completed: false },
    ],
  },
  {
    id: 'microservices',
    title: 'Microservices',
    completed: false,
    children: [
      { id: 'micro-1', title: 'Microservices Fundamentals', completed: false },
      { id: 'micro-2', title: 'Service Communication', completed: false },
      { id: 'micro-3', title: 'Service Discovery', completed: false },
      { id: 'micro-5', title: 'Circuit Breaker Pattern', completed: false },
      { id: 'micro-6', title: 'Bulkhead Pattern', completed: false },
      { id: 'micro-7', title: 'Microservices Best Practices', completed: false },
    ],
  },
  {
    id: 'big-data',
    title: 'Big Data Processing',
    completed: false,
    children: [
      { id: 'bigdata-1', title: 'Big Data Fundamentals', completed: false },
      { id: 'bigdata-2', title: 'MapReduce', completed: false },
      { id: 'bigdata-3', title: 'Batch Processing', completed: false },
      { id: 'bigdata-4', title: 'Stream Processing', completed: false },
      { id: 'bigdata-5', title: 'Data Pipelines', completed: false },
      { id: 'bigdata-6', title: 'ETL Processes', completed: false },
    ],
  },
  {
    id: 'observability',
    title: 'Observability',
    completed: false,
    children: [
      { id: 'obs-1', title: 'Logging', completed: false },
      { id: 'obs-2', title: 'Monitoring', completed: false },
      { id: 'obs-3', title: 'Tracing', completed: false },
      { id: 'obs-4', title: 'Alerting', completed: false },
    ],
  },
  {
    id: 'security',
    title: 'Security',
    completed: false,
    children: [
      { id: 'sec-1', title: 'Authentication & Authorization', completed: false },
      { id: 'sec-2', title: 'OAuth 2.0', completed: false },
      { id: 'sec-3', title: 'JWT Tokens', completed: false },
      { id: 'sec-4', title: 'Encryption', completed: false },
      { id: 'sec-5', title: 'DDoS Protection', completed: false },
      { id: 'sec-6', title: 'Security Best Practices', completed: false },
    ],
  },
];

const SystemDesignPractice: React.FC = () => {
  return (
    <DynamicPracticePage
      topicType="system-design"
      topics={topics}
      title="System Design"
    />
  );
};

export default SystemDesignPractice;
